export default __webpack_public_path__ + "static/app-features-1--mobile-e2a4d610da9a44b02ea1f8124b036b2e.png";